import { render, staticRenderFns } from "./ReviewImportPopup.vue?vue&type=template&id=d04bc82c"
import script from "./ReviewImportPopup.vue?vue&type=script&lang=js"
export * from "./ReviewImportPopup.vue?vue&type=script&lang=js"
import style0 from "./ReviewImportPopup.vue?vue&type=style&index=0&id=d04bc82c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports